module.exports = __webpack_public_path__ + "img/not-found.713a9810.svg";